// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notes-content {
    min-width: 300px;
    max-width: 600px;
    min-height: 100px;
}

.app-name {
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #e0e0e0;
}

.notes-text {
    white-space: pre-wrap;
    word-wrap: break-word;
    line-height: 1.6;
}

mat-dialog-actions {
    margin-top: 20px;
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/applications/Notes/notes-dialog.component.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,oBAAoB;IACpB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".notes-content {\n    min-width: 300px;\n    max-width: 600px;\n    min-height: 100px;\n}\n\n.app-name {\n    margin-bottom: 15px;\n    padding-bottom: 10px;\n    border-bottom: 1px solid #e0e0e0;\n}\n\n.notes-text {\n    white-space: pre-wrap;\n    word-wrap: break-word;\n    line-height: 1.6;\n}\n\nmat-dialog-actions {\n    margin-top: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
